import useLockBodyScroll from '@src/hooks/useLockBodyScroll';

type TProps = {
  scrollableElementRef?: {
    current: null | HTMLElement;
  };
};

function LockBodyScroll({ scrollableElementRef }: TProps) {
  useLockBodyScroll(scrollableElementRef.current);

  return null;
}

export default LockBodyScroll;
